// extracted by mini-css-extract-plugin
var _1 = "VtJt3__friend";
var _2 = "VtJt3__list";
var _3 = "VtJt3__onlineStatus";
var _4 = "VtJt3__onlineStatus_offline";
var _5 = "VtJt3__onlineStatus_online";
export { _1 as "friend", _2 as "list", _3 as "onlineStatus", _4 as "onlineStatus_offline", _5 as "onlineStatus_online" }
